import { get, writable } from "svelte/store"
import { getParameterByName } from "../utils"
import { defaultVAT } from "../../../api/hooks/config-client"
import { iframeView, referrer } from "./iframeIntegration"

export interface PredefinedContact {
    customerType: string
    firstname: string
    lastname: string
    company: string
    city: string
    street: string
    houseNumber: string
    postcode: string
    countryCode: string
    email: string
    phone: string
}
export const predefinedContact = writable<PredefinedContact>(null)
if (typeof window !== "undefined") {
    const predef: PredefinedContact = {
        customerType: getParameterByName("customerType"),
        firstname: getParameterByName("firstname"),
        lastname: getParameterByName("lastname"),
        company: getParameterByName("company"),
        city: getParameterByName("city"),
        street: getParameterByName("street"),
        houseNumber: getParameterByName("houseNumber"),
        postcode: getParameterByName("postcode"),
        countryCode: getParameterByName("countryCode"),
        email: getParameterByName("email"),
        phone: getParameterByName("phone"),
    }

    if (predef.email) {
        predefinedContact.set(predef)
    }
}

/////////////////////////// Offer Assistant

export let showOfferAssistant = writable<boolean>(false)

function gPredef() {
    return get(predefinedContact) || ({} as PredefinedContact)
}

export const inquiry = writable<ProductInquiry>({
    customerType: "end",
    desiredRetailPartner: "",
    dealerChoice: {
        number: 0,
        company: "no dealer",
        postcode: "00000",
    },
    account: null,
    contact: {
        email: gPredef().email || "",
        phone: gPredef().phone || "",
    },
    billingAddress: {
        firstname: gPredef().firstname || "",
        lastname: gPredef().lastname || "",
        company: gPredef().company || "",
        city: gPredef().city || "",
        street: gPredef().street || "",
        houseNumber: gPredef().houseNumber || "",
        postcode: gPredef().postcode || "",
        countryCode: gPredef().countryCode || "DE",
    },
    commission: "",
    constructionProject: "",
    cart: [],
    sum: {
        subtotalNet: 0,
        subtotalGross: 0,
        minQtyNet: 0,
        minQtyGross: 0,
        packagingNet: 0,
        packagingGross: 0,
        shippingNet: 0,
        shippingGross: 0,
        totalNet: 0,
        totalGross: 0,
        totalVAT: 0,
    },
    vat: defaultVAT,
    comment: "",
    offerAssistant: null,
    referrer: {
        url: get(referrer),
        iframe: get(iframeView),
        preselectedDealerNumber: null,
    },
})
